import type { Dispatch } from "@reduxjs/toolkit";
import { connectorLocalStorageKey } from "@vapordex/uikit";
import { PREDICTION_TOOLTIP_DISMISS_KEY } from "config/constants";
import { resetUserState } from "state/global/actions";
import getLocalStorageItemKeys from "./getLocalStorageItemKeys";
import { LS_ORDERS } from "./localStorageOrders";

export const clearUserStates = (
	dispatch: Dispatch<any>,
	chainId: number,
	isDeactive = false,
) => {
	dispatch(resetUserState({ chainId }));

	// Only clear localStorage when user disconnect,switch address no need clear it.
	if (isDeactive) {
		window?.localStorage?.removeItem(connectorLocalStorageKey);
	}
	const lsOrderKeys = getLocalStorageItemKeys(LS_ORDERS);

	for (const lsOrderKey of lsOrderKeys)
		window?.localStorage?.removeItem(lsOrderKey);

	window?.localStorage?.removeItem(PREDICTION_TOOLTIP_DISMISS_KEY);
};
